var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mb-2", class: ["col-" + _vm.colSize] }, [
    _c("div", { staticClass: "form-page" }, [
      _c("p", { staticClass: "text-justify" }, [
        _vm._v("\n      " + _vm._s(_vm.prompt) + "\n    "),
      ]),
      _vm._v(" "),
      _c("article", { staticClass: "d-flex mb-0" }, [
        _c(
          "div",
          { staticClass: "form-container fe-radio-form large-radio px-0" },
          [
            _c("div", { staticClass: "fe-option col-xs-12" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.answer,
                    expression: "answer",
                  },
                ],
                attrs: { id: "no-" + _vm.id, type: "radio", value: "0" },
                domProps: { checked: _vm._q(_vm.answer, "0") },
                on: {
                  change: [
                    function ($event) {
                      _vm.answer = "0"
                    },
                    _vm.handleChange,
                  ],
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "checkmark" }),
              _vm._v(" "),
              _c("label", { attrs: { for: "no-" + _vm.id } }, [
                _vm._v(_vm._s(_vm.$t("global.words.no"))),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-container fe-radio-form large-radio px-0" },
          [
            _c("div", { staticClass: "fe-option col-xs-12" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.answer,
                    expression: "answer",
                  },
                ],
                attrs: { id: "yes-" + _vm.id, type: "radio", value: "1" },
                domProps: { checked: _vm._q(_vm.answer, "1") },
                on: {
                  change: [
                    function ($event) {
                      _vm.answer = "1"
                    },
                    _vm.handleChange,
                  ],
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "checkmark" }),
              _vm._v(" "),
              _c("label", { attrs: { for: "yes-" + _vm.id } }, [
                _vm._v(_vm._s(_vm.$t("global.words.yes"))),
              ]),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }